import { Button, Box } from '@fabric-ds/react';
import type { Alternative } from 'types';

type Props = {
    alternative: Alternative;
};

const AlternativeBox = (props: Props) => {
    const {
        alternative: {
            actions: { alternatives },
        },
    } = props;
    return (
        <Box>
            <Button link rel="noreferrer" href={alternatives.link}>
                {alternatives.text}
            </Button>
        </Box>
    );
};

export default AlternativeBox;
